var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Airtime",
    transform: "translate(-242 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147997",
    "data-name": "Rectangle 147997",
    width: 47,
    height: 46,
    rx: 10,
    transform: "translate(242 590)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "electricity-svgrepo-com",
    d: "M14,2.221,8.907,0H5.093L0,2.221V4.132H4.574L1.948,13.081H.028V14H13.972v-.919h-1.92L9.426,4.132H14V2.221ZM5.648.919h2.7V3.213h-2.7V.919ZM5.533,4.132H8.467l.445,1.517L7,7.733,5.087,5.649ZM.919,3.213V2.823L4.729,1.162V3.213H.919ZM4.785,6.679,6.376,8.412,3.29,11.774Zm-1.447,6.4L7,9.092l3.662,3.989H3.338Zm7.372-1.306L7.624,8.412,9.215,6.679Zm2.37-8.562H9.271V1.162l3.809,1.662v.389Z",
    transform: "translate(259 606)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.abc6c204c405546de92a85f191d7f245.svg";
export { ForwardRef as ReactComponent };